
import { Fn, Fn0, Fn2, Fn3, Fn4, Fn5 }	from "ts-base/fn";

//-----------------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyFunction	= (...args:ReadonlyArray<any>) => any;

export namespace Functions {
	export const delay	= <T extends AnyFunction>(self:Fn0<T>):T	=>
		((...args) => self()(...(args))) as T;

	//-----------------------------------------------------------------------------

	export const curry = <S1, S2, T>(func:Fn2<S1, S2, T>):Fn<S1, Fn<S2, T>> =>
		s1 => s2 => func(s1, s2);

	/*
	export const curry3	= <S1,S2,S3,T>(func:Fn3<S1,S2,S3,T>):Fn<S1,Fn<S2,Fn<S3,T>>>	=>
		s1 => s2 => s3 => func(s1, s2, s3);

	export const curry4	= <S1,S2,S3,S4,T>(func:Fn4<S1,S2,S3,S4,T>):Fn<S1,Fn<S2,Fn<S3,Fn<S4,T>>>>	=>
		s1 => s2 => s3 => s4 => func(s1, s2, s3, s4);

	export const curry5	= <S1,S2,S3,S4,S5,T>(func:Fn5<S1,S2,S3,S4,S5,T>):Fn<S1,Fn<S2,Fn<S3,Fn<S4,Fn<S5,T>>>>>	=>
		s1 => s2 => s3 => s4 => s5 => func(s1, s2, s3, s4, s5);
	*/

	export type CurryN<F extends AnyFunction>	=
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		F extends (s1:any) => any							? F									:
		F extends (s1:infer S1, ...ss:infer SS) => infer T	? (s1:S1) => CurryN<(...ss:SS)=>T>	:
		never;

	export const curryN	= <F extends AnyFunction>(func:F):CurryN<F>	=>
		func.length === 0	? doesNotHappen(`function ${func.name} does not take any parameters`)	:
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		func.length === 1	? func as any													:
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		((arg:any) => curryN(func.bind(null, arg))) as any;

	const doesNotHappen = (message:string):never => { throw new Error(message); };

	//-----------------------------------------------------------------------------

	export const uncurry = <S1, S2, T>(fn:Fn<S1, Fn<S2, T>>):Fn2<S1, S2, T> =>
		(s1, s2) => fn(s1)(s2);

	export const uncurry3 = <S1, S2, S3, T>(fn:Fn<S1, Fn<S2, Fn<S3, T>>>):Fn3<S1, S2, S3, T> =>
		(s1, s2, s3) => fn(s1)(s2)(s3);

	export const uncurry4 = <S1, S2, S3, S4, T>(fn:Fn<S1, Fn<S2, Fn<S3, Fn<S4, T>>>>):Fn4<S1, S2, S3, S4, T> =>
		(s1, s2, s3, s4) => fn(s1)(s2)(s3)(s4);

	export const uncurry5 = <S1, S2, S3, S4, S5, T>(fn:Fn<S1, Fn<S2, Fn<S3, Fn<S4, Fn<S5, T>>>>>):Fn5<S1, S2, S3, S4, S5, T> =>
		(s1, s2, s3, s4, s5) => fn(s1)(s2)(s3)(s4)(s5);
}
